import { indivPageImg, mSEPreviewImg, tvInteractiveImg, vibesImg } from "../img/projImgsObj";
import { automationProjects, databaseProjects, emailProjects, interactiveProjects } from "./ProjectGroups";

export const Groups = [
    {
        title: "Interactive Experiences",
        subtitle: "Cross-functional projects to enhance existing technology and improve user experience.",
        img: tvInteractiveImg,
        link: "interactive",
        projects: interactiveProjects,
    },
    {
        title: "Database Integrations",
        subtitle: "Applications built to ingest, manage, and interact with large databases.",
        img: indivPageImg,
        link: "database",
        projects: databaseProjects,
    },
    {
        title: "Email Development",
        subtitle: "Responsive e-mail templates built and tested for cross-client compatibility.",
        img: vibesImg,
        link: "email",
        projects: emailProjects,
    },
    {
        title: "Automation Tools",
        subtitle: "Tools and scripts for improving creative workflows and efficiency.",
        img: mSEPreviewImg,
        link: "automation",
        projects: automationProjects,
    }
]